import { FinancialAccountDocumentType } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const financialAccountDocumentTypeMessages = defineMessages({
  debtPaymentProof: {
    defaultMessage: 'Debt payment proof',
    description: 'financial account document type title',
  },
  other: {
    defaultMessage: 'Other',
    description: 'financial account document type title',
  },
  otherWithOtherType: {
    defaultMessage: 'Other ({otherType})',
    description: 'financial account document type title',
  },
  proofOfDebt: {
    defaultMessage: 'Proof of debt',
    description: 'financial account document type title',
  },
})

export function translateFinancialAccountDocumentType(
  intl: IntlShape,
  type: FinancialAccountDocumentType,
  otherType: string | null,
): string {
  switch (type) {
    case FinancialAccountDocumentType.DEBT_PAYMENT_PROOF:
      return intl.formatMessage(financialAccountDocumentTypeMessages.debtPaymentProof)
    case FinancialAccountDocumentType.PROOF_OF_DEBT:
      return intl.formatMessage(financialAccountDocumentTypeMessages.proofOfDebt)
    case FinancialAccountDocumentType.OTHER:
      if (otherType) {
        return intl.formatMessage(financialAccountDocumentTypeMessages.otherWithOtherType, {
          otherType,
        })
      } else {
        return intl.formatMessage(financialAccountDocumentTypeMessages.other)
      }
  }
}
